import * as actionTypes from './actionTypes'
import axios from '../../httpClients/axios-datamerch'
import {authHeaders} from '../../helpers'
import {addToast} from './toasts'

export const clearMerchantScrubberImports = () => {
  return {
    type: actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_SUCCESS,
    merchant_scrubber_imports: []
  }
}

export const fetchMerchantScrubberImportsSuccess = (merchant_scrubber_imports) => {
  return {
    type: actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_SUCCESS,
    merchant_scrubber_imports: merchant_scrubber_imports
  }
}

export const fetchMerchantScrubberImportsFail = (error) => {
  return {
    type: actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_FAIL,
    error: error
  }
}

export const fetchMerchantScrubberImportsStart = () => {
  return {
    type: actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_START
  }
}

export const fetchMerchantScrubberImports = (account_id) => { 
  return dispatch => {
    dispatch(fetchMerchantScrubberImportsStart())
    let url = `accounts/${account_id}/merchant_scrubber_imports`
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        const fetchedMerchantScrubberImports = []
        for(let key in response.data.data){
          fetchedMerchantScrubberImports.push({
            ...response.data.data[key],
            id: key
          })
        }
        dispatch(fetchMerchantScrubberImportsSuccess(fetchedMerchantScrubberImports))
      }
      else {
        dispatch(fetchMerchantScrubberImportsFail('Unable to load merchant scrubber imports.'))
        dispatch(addToast({
          message: 'An error occurred while attempting to retrieve merchant scrubber imports.',
          severity: 'error',
          duration: null
        }))
      }
    })
    .catch(error => {
      dispatch(fetchMerchantScrubberImportsFail(error.response.data.errors))
      dispatch(addToast({
        message: error.response.data.errors,
        severity: 'error',
        duration: null
      }))
    })
  }
}

export const fetchMerchantScrubberUsageSuccess = (usage) => {
  return {
    type: actionTypes.FETCH_MERCHANT_SCRUBBER_USAGE_SUCCESS,
    usage: usage
  }
}

export const fetchMerchantScrubberUsage = (account_id) => {
  return dispatch => {
    let url = `accounts/${account_id}/merchant_scrubber_imports/usage`
    axios.get(url, authHeaders())
    .then(response => {
      if (response) {
        dispatch(fetchMerchantScrubberUsageSuccess(response.data.data))
      }
    })
    .catch(() => {
      // Usage is informational; the API still enforces the limits on upload.
    })
  }
}

export const openMerchantScrubberDialog = (id) => {
    return {
      type: actionTypes.OPEN_MERCHANT_SCRUBBER_DIALOG,
      id: id
    }
  }
  
export const closeMerchantScrubberDialog = () => {
    return {
        type: actionTypes.CLOSE_MERCHANT_SCRUBBER_DIALOG
    }
}


export const addMerchantScrubberStart = () => {
    return {
        type: actionTypes.ADD_MERCHANT_SCRUBBER_START
    }
}
  
export const addMerchantScrubberSuccess = (id, merchantScrubberData) => {
    return {
        type: actionTypes.ADD_MERCHANT_SCRUBBER_SUCCESS,
        id: id,
        merchantScrubberData: merchantScrubberData
    }
}

export const addMerchantScrubberFail = (error) => {
    return {
        type: actionTypes.ADD_MERCHANT_SCRUBBER_FAIL,
        error: error
    }
}

export const addMerchantScrubber = (fein, account_id, page, per_page, search) => {
    const modifiedMerchantScrubberData = {
        merchant_scrubber: {
        fein: fein
        }
    }

    return dispatch => {
        dispatch(addMerchantScrubberStart())
        let url = `/accounts/${account_id}/merchant_scrubbers`
        let config = authHeaders()
        axios.post(url, modifiedMerchantScrubberData, config)
        .then(response => {
        if (response){
            const data = response.data.data
            dispatch(addMerchantScrubberSuccess(data.resource_id, data))
            dispatch(addToast({
            message: 'Merchant scrubber has been added to DataMerch.',
            severity: 'success'
            }))
            dispatch(fetchMerchantScrubberImports(account_id, page, per_page, search))
        } else {
            dispatch(addMerchantScrubberFail('An error occurred while attempting to create merchant scrubber.'))
            dispatch(addToast({
            message: 'An error occurred while attempting to create merchant scrubber.',
            severity: 'error',
            duration: null
            }))
        }
        })
        .catch(error => {
        dispatch(addMerchantScrubberFail(error.response.data.errors))
        dispatch(addToast({
            message: error.response.data.errors,
            severity: 'error',
            duration: null
        }))
        })
    }
}
  
